export const capitalizeFirstLetter = (input: string) => {
    const result = input.charAt(0).toUpperCase() + input.slice(1);
    return result;
};
